import { useNavigate } from "react-router-dom";
import { DEFAULT_FIRST_FORM_VALUE, useFilterStore } from "../stores/FilterStore";
import { useFormContext } from "../SearchFormContext";
import { useEffect } from "react";

export const useTempFormSubmit = () => {
  const {
    county,
    setCounty,
    bedrooms,
    setBedrooms,
    minPrice,
    setMinPrice,
    maxPrice,
    setMaxPrice,
  } = useFilterStore([
    "county",
    "setCounty",
    "bedrooms",
    "setBedrooms",
    "minPrice",
    "setMinPrice",
    "maxPrice",
    "setMaxPrice",
  ]);

  const navigate = useNavigate();

  const { formValues, setTempValues } = useFormContext();
  const formDisabled = formValues.county === DEFAULT_FIRST_FORM_VALUE;

  const confirmSearch = () => {
    if (formDisabled) return null;

    if (formValues.county !== county) {
      setCounty(formValues.county);
    }

    function updateStateIfDifferent<T>(formValue: T, currentValue: T, setter: (value: T | 'any') => void): void {
      const newValue = formValue === DEFAULT_FIRST_FORM_VALUE ? "any" : formValue;
      if (newValue !== currentValue) {
        setter(newValue);
      }
    }
    
    updateStateIfDifferent(formValues.bedrooms, bedrooms, setBedrooms);
    
    updateStateIfDifferent(formValues.minPrice, minPrice, setMinPrice);
    
    updateStateIfDifferent(formValues.maxPrice, maxPrice, setMaxPrice);

    navigate(formValues.county);
  };

  useEffect(() => {
    setTempValues("county", county);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [county]);

  return { confirmSearch, formDisabled }
}